// extracted by mini-css-extract-plugin
export default {"mainBlock":"style_mainBlock__UnCxG","image":"style_image__H+GEr","descriptionText":"style_descriptionText__U5uYw","description":"style_description__dh+1B"};